module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-container-single element-non-bodymatter element-type-image image-element",
    attrs: {
      "id": "full-page-image-2"
    }
  }, [_c('div', {
    staticClass: "image-element-block image-element-aspect-tall"
  }, [_c('div', {
    staticClass: "image-element-size-container"
  }, [_c('img', {
    staticClass: "image-element-image",
    attrs: {
      "alt": "Full Page Image",
      "src": "images/jason-berry-christ-centered-fitness-_043-cropped-reversed.jpg"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c449582c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/full-page-image-2.vue
// module id = 78
// module chunks = 0